const ALLOWED_HOSTS = [
  'airbnb.com',
  'www.airbnb.com',
  'airbnb.com.br',
  'www.airbnb.com.br'
];

const ALLOWED_SUFFIXES = ['.airbnb.com', '.airbnb.com.br'];

/**
 * Valida a URL externa de reserva (anúncio no Airbnb) vinda da API.
 *
 * Retorna a URL segura para redirecionamento ou `null` quando inválida.
 * Regras: URL absoluta, protocolo https e hostname exatamente na allowlist
 * (ou subdomínio dela). A comparação é feita sobre o hostname parseado —
 * nunca sobre a string bruta, para impedir open redirect
 * (ex.: https://airbnb.com.br.attacker.io ou https://evil.io/?x=airbnb.com.br).
 */
export const getSafeExternalBookingUrl = (
  url: string | null | undefined
): string | null => {
  if (!url) {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  if (parsed.protocol !== 'https:') {
    return null;
  }

  const host = parsed.hostname.toLowerCase();
  if (ALLOWED_HOSTS.includes(host)) {
    return parsed.href;
  }
  if (ALLOWED_SUFFIXES.some((suffix) => host.endsWith(suffix))) {
    return parsed.href;
  }

  return null;
};
